import * as d3 from 'd3-selection'
import * as colors from 'colors'

export const spike = function (width, height) {
  return `M${-width / 2},0L0,${-height}L${width / 2},0`
}

export const spikeGradient = (selection, color, transition) => {
  selection.each(function (d) {
    let gradient = d3.select(this)
                     .selectAll(`linearGradient.${color}`)
                     .data([color])
      , enter = gradient.enter()
                        .append('linearGradient')

    enter.merge(gradient)
         .attr('x1', '0%') // top to bottom gradient
         .attr('x2', '0%')
         .attr('y1', '0%')
         .attr('y2', '100%')
         .attr('class', d => `spike-gradient ${d}`)
         .attr('id', d => `spike-gradient-${d}`)

    enter.append('stop')
         .attr('offset', 0)
         .attr('stop-opacity', 1)
         .attr('stop-color', colors.adjustLightness(colors.lookup(color), 10))
    enter.append('stop')
         .attr('offset', 1)
         .attr('stop-opacity', 0)
         .attr('stop-color', colors.adjustLightness(colors.lookup(color), -10))

    if (transition) {
      transition.end().then(() => {
        gradient.exit().remove()
      }).catch(() => {
        // interrupted transition, ignore
      })
    } else {
      gradient.exit().remove()
    }
  })
}

/*
 * Returns true if any point of the circle, defined by x, y, r, is within the rect bounding box
 */
export const circleInRect = function (circle, rect) {
  // Find distance between circle center and bounding box center
  const width = rect[1][0] - rect[0][0]
      , height = rect[1][1] - rect[0][1]
      , distX = Math.abs(circle.x - rect[0][0] - width / 2)
      , distY = Math.abs(circle.y - rect[0][1] - height / 2)

  // If the distance is greater than half circle + half rect, they are too far apart
  if (distX > (width / 2 + circle.r)) {
    return false
  }
  if (distY > (height / 2 + circle.r)) {
    return false
  }

  // If the distance is less than half then they are colliding
  if (distX <= (width / 2)) {
    return true
  }
  if (distY <= (height / 2)) {
    return true
  }

  // Check if they are intersecting at the bounding box corners
  const dx = distX - width / 2
      , dy = distY - height / 2

  return (dx * dx + dy * dy <= (circle.r * circle.r))
}

/*
 * Returns the bounding box of all the `bounds`, where each
 * item in `bounds` is a two dimensional array containing the
 * top/left point at [0] and bottom/right point at [1]. Weird way to store
 * points, but it's consistent with the bounds returned by d3's path.bounds.
 */
export const boundingBox = function (bounds) {
  return bounds.reduce(function (p, bb) {
    return [
      [Math.min(p[0][0], bb[0][0]), Math.min(p[0][1], bb[0][1])],
      [Math.max(p[1][0], bb[1][0]), Math.max(p[1][1], bb[1][1])]
    ]
  }, [[Infinity, Infinity], [-Infinity, -Infinity]])
}

/*
 * Determines if the `point` is within the box
 */
export const pointInBox = function (point, box) {
  return box[0][0] <= point[0] &&
         point[0] <= box[1][0] &&
         box[0][1] <= point[1] &&
         point[1] <= box[1][1]
}

/*
 * Determines if two bounding boxes intersect
 */
export const intersect = function (box1, box2) {
  return !(box2[0][0] > box1[1][0] ||
           box2[1][0] < box1[0][0] ||
           box2[0][1] > box1[1][1] ||
           box2[1][1] < box1[0][1])
}
